import { useAuthedUser } from '../../../common/providers/AuthedUserProvider';
import type { Card } from '../../types/Card';
import { CardForm, CardStatus } from '../../types/Card';
import useGetAllBankAccountDetailsFromGlobalState from '../useGetAllBankAccountDetailsFromGlobalState';

const useUnactivatedPhysicalCard = (): {
    card: Card | null;
    isLoading: boolean;
} => {
    const user = useAuthedUser();
    const { bankAccountDetails, isLoading } =
        useGetAllBankAccountDetailsFromGlobalState();

    const card =
        bankAccountDetails
            .flatMap((account) => account.cards ?? [])
            .find(
                (c) =>
                    c.form === CardForm.PHYSICAL &&
                    c.cardStatus === CardStatus.UNACTIVATED &&
                    c.syncteraPersonId === user.syncteraPersonId,
            ) ?? null;

    return { card, isLoading };
};

export default useUnactivatedPhysicalCard;
